// This is just an example,
// so you can safely delete all default props below

export default {
    profile: 'Min profil',
    given_name: 'Fornavn',
    family_name: 'Etternavn',
    address_line_1: 'Adresse',
    postal_code: 'Postnr.',
    locality: 'Poststed',
    country_code: 'Land',
    phone_number: 'Mobiltelefonnr.',
    email: 'E-post',
    email_repeat: 'Gjenta e-post',
    error_given_name: 'Fornavn må oppgis',
    error_family_name: 'Etternavn må oppgis',
    error_address_line_1: 'Adresse må oppgis',
    error_postal_code: 'Postnr. må oppgis',
    error_locality: 'Poststed må oppgis',
    error_country_code: 'Land må oppgis',
    error_phone_number: 'Mobiltelefonnr. er ikke gyldig',
    error_email: 'E-post er ikke gyldig',
    error_email_repeat: 'Repetert e-post må være den samme som oppgitt e-post',
    error_email_exist: 'E-post adr. er allerede i bruk',
    update:'Oppdater',
    update_success: 'Oppdatering vellykket',
}
